import { Injectable } from '@angular/core';
import { ResponseCodeDTO } from 'src/app/shared/dto/response-codes.dto';
import { AxiosService } from 'src/app/core/axios';
import { environment } from 'src/environments/environment';
import { ProfileDto } from '../panel-start/dto/profile';

interface UpdateProfileDTO {
  name: string;
  lastName: string;
  country_code: string;
  country: string;
  state_code: string;
  state: string;
  city_code: string;
  city: string;
  email: string;
  phone: {
    code: string;
    number: string;
  };
  password: string;
}

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  constructor(private readonly axios: AxiosService) {
    // do nothing
  }

  async getInfo(): Promise<ProfileDto> {
    const result: ResponseCodeDTO = await this.axios.get(`${environment.apiUrl}user/getInfo`);
    return result.code.code === 'PTZ0000' ? result.data : [];
  }

  async updateProfile(profileData: UpdateProfileDTO): Promise<ResponseCodeDTO> {
    const result: ResponseCodeDTO = await this.axios.patch(`${environment.apiUrl}user/updateProfileInfo`, profileData);
    return result;
  }
}
